/** Running from local webserver. */
export const isRunningLocal =
  globalThis.location.hostname.endsWith('.localhost');

/** Running in Storybook local or deployed to GitLab Pages. */
export const isRunningStorybook =
  globalThis.location.port === '6006' ||
  globalThis.location.hostname === 'obsec1.gitlab.io' ||
  globalThis.location.hostname === 'obi-ui.frontend.pages.obsec.io'; // this one will be deprecated eventually

/** Jest unit test environment (yarn test). */
export const isTestEnv = import.meta.env.MODE === 'test';
